export default "__VITE_ASSET__CF22ltjt__"